import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
    AdornedInput,
    Adornment,
    FormField,
    IconSearch,
    mediaBreakpointMixin,
    StyledInput,
    token,
} from '@zillow/constellation';

const SearchBox = ({ actionPrefix, className, onFocus, onBlur }) => {
    const [query, setQuery] = useState('');

    return (
        <StyledSearchForm
            action={`${actionPrefix}/${query}`}
            className={className}
        >
            <SearchBoxFormField
                title="Search Learning Center"
                control={
                    <SearchBoxAdornedInput
                        input={
                            <SearchBoxInput
                                id="learn-search"
                                onChange={(e) => setQuery(e.target.value)}
                                placeholder="Search Learning Center"
                                onFocus={onFocus}
                                onBlur={onBlur}
                                required
                                pattern=".*\S+.*"
                            />
                        }
                        leftAdornment={
                            <SearchBoxAdornment htmlFor="learn-search">
                                <IconSearch
                                    fontColor="brand"
                                    title="Search Learning Center"
                                />
                            </SearchBoxAdornment>
                        }
                    />
                }
            />
        </StyledSearchForm>
    );
};

const StyledSearchForm = styled.form`
    flex: 0 0 100%;
`;

const SearchBoxInput = styled(StyledInput)`
    background: transparent !important;
    border: none;
    border-radius: 0;
    color: ${token('colors.brand')};
    font-weight: 600;

    font-size: ${token('fontSizes.bodySmall')}px;

    &::placeholder {
        color: ${token('colors.blue375')};
        font-weight: 600;
        opacity: 1;
        overflow: visible;
    }
`;
// Cannot use StyledAdornment as it loses it position styling, and gets thrown
// to right side.
const SearchBoxAdornment = styled(Adornment)`
    background: transparent !important;
    border: none;
`;

// Cannot use StyledAdornedInput here as it completely loses its important styles.
const SearchBoxAdornedInput = styled(AdornedInput)`
    background: ${token('colors.blue200')} !important;
    border-radius: ${token('radii.pill')};
    width: 300px;

    &:focus-within {
        border-radius: ${token('radii.pill')};
    }

    @media ${mediaBreakpointMixin('md_lte')} {
        width: auto;
        &:not(:focus-within) {
            width: 42px;
            overflow: hidden;
            ${SearchBoxAdornment} {
                transform: translateX(-3px);
            }
        }
    }
`;

const SearchBoxFormField = styled(FormField)`
    @media ${mediaBreakpointMixin('md_lte')} {
        &:not(:focus-within) {
            width: 42px;
        }
    }
`;

SearchBox.propTypes = {
    className: PropTypes.string,
    actionPrefix: PropTypes.string.isRequired,
};

SearchBox.defaultProps = {
    className: undefined,
};

export default SearchBox;
